import React, { useState, useEffect } from 'react';

// Sample categories and subcategories data
const initialCategories = [
  'Electronics',
  'Home Appliances',
  'PersonalCare',
  'Fashion',
  'Grocery/Health',
];

const initialSubCategories = [
  { id: 1, name: 'Smart LED TV', category: 'Electronics', status: 'Deactive' },
  { id: 2, name: 'Water Purifier', category: 'Home Appliances', status: 'Deactive' },
  { id: 3, name: 'Hand & Palm', category: 'PersonalCare', status: 'Deactive' },
  { id: 4, name: "women's", category: 'PersonalCare', status: 'Deactive' },
  { id: 5, name: "Men's", category: 'PersonalCare', status: 'Deactive' },
  { id: 6, name: 'Health', category: 'Grocery/Health', status: 'Deactive' },
  { id: 7, name: 'All Grocery & Others', category: 'Grocery/Health', status: 'Deactive' },
  { id: 8, name: 'Beverages', category: 'Grocery/Health', status: 'Deactive' },
  { id: 9, name: 'Coffee & Tea', category: 'Grocery/Health', status: 'Deactive' },
  { id: 10, name: 'Snack Foods', category: 'Grocery/Health', status: 'Deactive' },
  { id: 11, name: "Top Brand's", category: 'Home Appliances', status: 'Deactive' },
  { id: 12, name: 'Small Home Appliances', category: 'Home Appliances', status: 'Deactive' },
  { id: 13, name: 'Kitchen Appliances', category: 'Home Appliances', status: 'Deactive' },
  { id: 14, name: 'Washing Machine', category: 'Home Appliances', status: 'Deactive' },
  { id: 15, name: "Kid's", category: 'Fashion', status: 'Deactive' },
  { id: 16, name: 'Women\'s', category: 'Fashion', status: 'Deactive' },
  { id: 17, name: 'Men\'s', category: 'Fashion', status: 'Deactive' },
  { id: 18, name: 'AC', category: 'Electronics', status: 'Active' },
  { id: 19, name: 'Refrigerator', category: 'Electronics', status: 'Active' },
  { id: 20, name: 'Mobile', category: 'Electronics', status: 'Active' }
];

const SubCategory = () => {
  const [categories] = useState(initialCategories);
  const [subCategories, setSubCategories] = useState(initialSubCategories);
  const [subCategoryName, setSubCategoryName] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [image, setImage] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [isCreateMode, setIsCreateMode] = useState(true);
  const [status, setStatus] = useState('Deactive');
  const [visibleSubCategories, setVisibleSubCategories] = useState([]);
  const [page, setPage] = useState(1);
  const subCategoriesPerPage = 3;

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubCategoryChange = (e) => {
    setSubCategoryName(e.target.value);
  };

  const handleCancel = () => {
    setSubCategoryName('');
    setCategoryName('');
    setImage(null);
    setStatus('Deactive');
    setSelectedSubCategory(null);
    setIsCreateMode(true);
  };

  const handleCreateSubCategory = () => {
    if (subCategoryName.trim() && categoryName) {
      const newSubCategory = {
        id: subCategories.length + 1,
        name: subCategoryName,
        category: categoryName,
        status,
        image: image ? image.name : 'No image',
      };
      setSubCategories([...subCategories, newSubCategory]);
      handleCancel();
    }
  };

  const handleUpdateSubCategory = () => {
    if (subCategoryName.trim() && selectedSubCategory) {
      const updatedSubCategories = subCategories.map((subCategory) =>
        subCategory.id === selectedSubCategory.id
          ? { ...subCategory, name: subCategoryName, category: categoryName, status, image: image ? image.name : subCategory.image }
          : subCategory
      );
      setSubCategories(updatedSubCategories);
      handleCancel();
    }
  };

  const handleDeleteSubCategory = (subCategoryId) => {
    const filteredSubCategories = subCategories.filter(
      (subCategory) => subCategory.id !== subCategoryId
    );
    setSubCategories(filteredSubCategories);
  };

  const handleSelectSubCategory = (subCategory) => {
    setSelectedSubCategory(subCategory);
    setSubCategoryName(subCategory.name);
    setCategoryName(subCategory.category);
    setStatus(subCategory.status);
    setIsCreateMode(false);
  };

  const handleActivateDeactivate = (subCategoryId) => {
    const updatedSubCategories = subCategories.map((subCategory) =>
      subCategory.id === subCategoryId
        ? { ...subCategory, status: subCategory.status === 'Active' ? 'Deactive' : 'Active' }
        : subCategory
    );
    setSubCategories(updatedSubCategories);
  };

  const loadMoreSubCategories = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const handleScroll = (e) => {
    if (e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight) {
      loadMoreSubCategories();
    }
  };

  useEffect(() => {
    const firstIndex = (page - 1) * subCategoriesPerPage;
    const lastIndex = firstIndex + subCategoriesPerPage;
    setVisibleSubCategories(subCategories.slice(firstIndex, lastIndex));
  }, [page, subCategories]);

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', padding: '20px' }}>
      <h1 style={{ textAlign: 'center', color: '#333', fontSize: '24px' }}>
        {isCreateMode ? 'Create Sub Category' : 'Update Sub Category'}
      </h1>
      <div>
        <label>Select Category Name</label>
        <select
          value={categoryName}
          onChange={(e) => setCategoryName(e.target.value)}
          style={{
            padding: '8px',
            fontSize: '14px',
            margin: '10px',
            width: '100%',
            borderRadius: '4px',
            border: '1px solid #ddd',
          }}
        >
          <option value="">Select Category</option>
          {categories.map((category, index) => (
            <option key={index} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label>Enter Sub Category Name</label>
        <input
          type="text"
          value={subCategoryName}
          onChange={handleSubCategoryChange}
          placeholder="Enter Sub Category Name"
          style={{
            padding: '8px',
            fontSize: '14px',
            margin: '10px',
            width: '100%',
            borderRadius: '4px',
            border: '1px solid #ddd',
          }}
        />
      </div>

      <div>
        <label>Upload Image</label>
        <input
          type="file"
          onChange={handleImageChange}
          style={{
            margin: '10px',
            padding: '6px',
            fontSize: '14px',
          }}
        />
        <span>{image ? image.name : 'No file chosen'}</span>
      </div>

      <div>
        <label>Status</label>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          style={{
            padding: '8px',
            fontSize: '14px',
            margin: '10px',
            width: '100%',
            borderRadius: '4px',
            border: '1px solid #ddd',
          }}
        >
          <option value="Active">Active</option>
          <option value="Deactive">Deactive</option>
        </select>
      </div>

      <div style={{ textAlign: 'center' }}>
        <button
          onClick={isCreateMode ? handleCreateSubCategory : handleUpdateSubCategory}
          style={{
            padding: '10px 20px',
            marginRight: '10px',
            backgroundColor: '#4CAF50',
            color: 'white',
            fontSize: '14px',
            borderRadius: '4px',
            border: 'none',
          }}
        >
          {isCreateMode ? 'Create' : 'Update'} Sub Category
        </button>
        <button
          onClick={handleCancel}
          style={{
            padding: '10px 20px',
            backgroundColor: '#f44336',
            color: 'white',
            fontSize: '14px',
            borderRadius: '4px',
            border: 'none',
          }}
        >
          Cancel
        </button>
      </div>

      <h2 style={{ marginTop: '40px', textAlign: 'center', fontSize: '18px' }}>Sub Category List</h2>
      <div
        style={{
          maxHeight: '400px',
          overflowY: 'auto',
          marginBottom: '20px',
          border: '1px solid #ddd',
        }}
        onScroll={handleScroll}
      >
        <table
          border="1"
          cellPadding="5"
          cellSpacing="0"
          style={{
            width: '100%',
            marginTop: '20px',
            fontSize: '14px',
            borderCollapse: 'collapse',
          }}
        >
          <thead style={{ backgroundColor: '#f2f2f2' }}>
            <tr>
              <th>Sr. No.</th>
              <th>Sub Category Name</th>
              <th>Category Name</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {visibleSubCategories.map((subCategory, index) => (
              <tr
                key={subCategory.id}
                style={{
                  backgroundColor: index % 2 === 0 ? '#fafafa' : '#fff',
                  cursor: 'pointer',
                }}
                onClick={() => handleSelectSubCategory(subCategory)}
              >
                <td>{subCategory.id}</td>
                <td>{subCategory.name}</td>
                <td>{subCategory.category}</td>
                <td>{subCategory.status}</td>
                <td>
                  <button
                    onClick={() => handleActivateDeactivate(subCategory.id)}
                    style={{
                      padding: '5px 10px',
                      fontSize: '14px',
                      backgroundColor: subCategory.status === 'Active' ? 'red' : 'green',
                      color: 'white',
                      borderRadius: '4px',
                      border: 'none',
                      marginRight: '10px',
                    }}
                  >
                    {subCategory.status === 'Active' ? 'Deactivate' : 'Activate'}
                  </button>
                  <button
                    onClick={() => handleDeleteSubCategory(subCategory.id)}
                    style={{
                      padding: '5px 10px',
                      fontSize: '14px',
                      backgroundColor: 'red',
                      color: 'white',
                      borderRadius: '4px',
                      border: 'none',
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div style={{ textAlign: 'center' }}>
        {page > 1 && (
          <button
            onClick={() => setPage(page - 1)}
            style={{
              padding: '5px 10px',
              fontSize: '14px',
              backgroundColor: '#007bff',
              color: 'white',
              borderRadius: '4px',
              border: 'none',
              marginRight: '10px',
            }}
          >
            Previous
          </button>
        )}
        <button
          onClick={loadMoreSubCategories}
          style={{
            padding: '5px 10px',
            fontSize: '14px',
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '4px',
            border: 'none',
          }}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default SubCategory;
